<div class="login">
  <div class="image-wrapper pr-xl-1">
    <!-- Image Slider -->
    <div #fpImageSliderRef [class.hide]="!slider" class="keen-slider image-slider">
      @for (img of imageSources; track img) {
        <div class="keen-slider__slide">
          <img alt="" class="main-img" [src]="img" />
        </div>
      }
    </div>
    <img alt="" class="icon-size" src="assets/logo/logo.png" />
    <div [class.hide]="!slider" class="slider-position">
      <div class="navigation-wrapper">
        <div #fpSliderRef class="keen-slider text-wrapper">
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Welcome to your club community!</h6>
              <p translate>Stay networked with your club, exchange ideas and organize everything in one place.</p>
            </div>
          </div>
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Everything you need for your club - in one place.</h6>
              <p translate>Simply register, contact members, plan appointments and achieve more together.</p>
            </div>
          </div>
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Stay connected - anytime, anywhere.</h6>
              <p translate>Access important information, share news and collaborate with your team.</p>
            </div>
          </div>
        </div>
        <div class="align-arrow-right mt-24">
          <app-icon (click)="slider.prev()" [cssStyle]="{ cursor: 'pointer', color: 'var(--white)' }" color="var(--white)" iconName="left-arrow-circle" size="55px"></app-icon>
          @if (slider) {
            <app-icon (click)="slider.next()" [cssStyle]="{ cursor: 'pointer', marginLeft: '22px' }" color="var(--white)" iconName="right-arrow-circle" size="55px"></app-icon>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="login-form padding-m">
    <div>
      <div class="d-flex">
        <app-icon [cssStyle]="{ marginBottom: '-20px' }" iconName="logo" size="28px"></app-icon>&nbsp;
        <span class="login-form__logo-text">{{ 'APP_NAME' | translate }}</span>
        <!--          <app-icon size="100px" iconName="logo-text"></app-icon>-->
      </div>
      <h2 class="heading-text mt-50" translate>Forgot Password</h2>
    </div>
    @if (alertMessage) {
      <div class="mt-25">
        <app-alert-message [alertType]="alertType" [message]="alertMessage | translate" [showCloseIcon]="false" size="small"></app-alert-message>
      </div>
    }
    <ng-container>
      <form (ngSubmit)="submit()" [formGroup]="form" class="mt-50 padding-m">
        <div>
          <label for="username" translate>loginForm.Username</label>
          <div class="input-icon-prefix mt-10">
            <input [placeholder]="'loginForm.Username' | translate" class="login-form__input" formControlName="username" id="username" name="username" type="text" />
            <app-icon [cssStyle]="{ marginBottom: '-9px' }" color="var(--slate-gray)" iconName="envelope"></app-icon>
          </div>
          <app-form-error [control]="form.get('username')" [name]="'Username' | translate"></app-form-error>
        </div>
        <p class="mt-16 normal-text" routerLink="/login" translate>Back to login</p>
        <div class="mt-26">
          <app-button
            (click)="submit()"
            [disabled]="form.invalid"
            [idleText]="'Submit' | translate"
            [isLoading]="isLoading"
            [type]="'Submit' | translate"
            cssClass="button-primary button-full"
            size="large"
          ></app-button>
        </div>
      </form>
    </ng-container>
  </div>
</div>

<div class="lang-selector">
  <img alt="-" class="lang-flag-icon" src="assets/lang-flags/{{ selectedLanguage.toLowerCase() }}.png" />
  <app-language-selector (selectedLanguage)="selectedLanguage = $event" [openAbove]="true"></app-language-selector>
</div>
